<template lang="pug">
form(@submit.prevent="onConfirm")
  modal.active(
    :active="showModal",
    @close="$emit('close')",
    :title="`Cancelar OS-m (${current.numero}/${current.ano})`"
  )
    div(slot="modal-body")
      h4.text-warning Atenção
      p Após cancelado não será possível reabrir.
      p
        span.text-bold Tenha certeza
        |
        | antes de cancelar!
      .divider
      form-group(
        label="Informe o motivo do cancelamento",
        :validation="$v.form.motivo"
      )
        textarea.form-input(v-model="$v.form.motivo.$model", rows="4")
      form-group(label="Adminstrativo")
        label.form-switch
          input(type="checkbox", v-model="form.administrativo")
          i.form-icon
          | Cancelar Sem Erro Fiscal
        .abbr O cancelamento sem erro fiscal não desconta a pontuação de produtividade do fiscal.

    div(slot="modal-footer")
      button.btn.btn-primary(
        :disabled="$v.$invalid || loading",
        :class="{ loading }"
      )
        btn-content(name="confirm", label="Cancelar")
</template>

<script>
import toastErrors from "@/lib/errors/toastErrors"
import { minLength, required } from "vuelidate/lib/validators"

export default {
  vuex: {
    servicos: {
      state: ["current"],
      actions: ["fetchCancelar"],
    },
  },
  data() {
    return {
      loading: false,
      showModal: true,
      form: {
        motivo: "",
        administrativo: false,
      },
    }
  },
  methods: {
    async onConfirm() {
      try {
        this.loading = true
        const { id } = this.current
        const params = { id, ...this.form }
        await this.fetchCancelar(params)
        this.$toaster.success("Cancelado com sucesso")
        this.$emit("close")
      } catch (e) {
        toastErrors(e)
      } finally {
        this.loading = false
      }
    },
  },
  validations: {
    form: {
      motivo: {
        required,
        minLength: minLength(10),
      },
    },
  },
}
</script>
